import { Link } from 'react-router-dom'
import { ReactComponent as Error } from '../assets/icons/error.svg'
import { ReactComponent as SchoolIcon } from '../assets/icons/school-icon.svg'
import { ReactComponent as Logo } from '../assets/icons/klassmate.svg'

export default function NotFound() {
  return (
    <div className='wrapper'>
      <div className='container mx-auto my-70'>
        <div className='flex flex-col items-center justify-center w-full h-full gap-32'>
          <div className='flex items-center gap-6'>
            <SchoolIcon className='h-[26px] w-[26px]' />
            <Logo className='h-16 w-[112px]' />
          </div>
          <Error className='h-[168px] w-[168px] shrink-0' />
          <div className='flex flex-col items-center gap-28'>
            <div className='flex flex-col gap-8'>
              <p className='text-center shrink-0 text-h1-semibold text-primary-normal'>
                페이지를 찾을 수 없습니다.
              </p>
              <p className='text-center shrink-0 text-body2-long-medium text-label-info'>
                페이지가 존재하지 않거나, 사용할 수 없는 페이지입니다. <br />
                입력하신 주소가 정확한지 다시 한 번 확인해주세요.
              </p>
            </div>
            <Link to={'/'} className='button_solid_primary_lg w-fit shrink-0'>
              메인으로 돌아가기
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
